<template>
  <div class="stage">
      <div class="dot-bricks"></div>
  </div>
</template>
<script>
export default {};
</script>
